module.exports = __webpack_public_path__ + "img/industry-banner-icon1.e4d95641.png";